import React from 'react'
import Page from 'contexts/page'
import WorkSchedulesProvider from 'contexts/work-schedules'
import AbsenceTypesProvider from 'contexts/absence-types'
import { useAccess } from 'contexts/access'
import Routing from './routing'

const AbsencePage = ({ upgradable, ...props }) => {
    const { check } = useAccess()
    const absenceAdmin = check('absence:manage')

    return (
        <Page
            view="absence"
            title={{
                id: 'noun_absence',
                defaultMessage: 'Absence'
            }}
            upgrade={{
                enabled: upgradable,
                passthrough: true
            }}>
            <WorkSchedulesProvider fetchAccess={!upgradable}>
                <AbsenceTypesProvider
                    fetchAccess={!upgradable}
                    includePolicies={absenceAdmin}>
                    {({ hasFetched: hasFetchedAbsenceTypes }) => (
                        <Routing
                            {...props}
                            upgradable={upgradable}
                            hasFetchedAbsenceTypes={hasFetchedAbsenceTypes} />
                    )}
                </AbsenceTypesProvider>
            </WorkSchedulesProvider>
        </Page>
    )
}

export default AbsencePage